module.exports = __webpack_public_path__ + "img/icon19.7ae77165.png";